import {
    Grid
} from '@material-ui/core';
import Box from '@mui/material/Box';
import { styleCollaboratorTab as style } from '../../Prestaciones/css/styleSheet';
import { Dispatch, SetStateAction } from 'react';
import { removeAccents } from '../../../helpers/RemoveAccents';


interface Props<T> {  
    initState: Array<T>;
    setState: Dispatch<SetStateAction<T[]>> | ((a: T[]) => void);
    stateInitial: Array<T>;
    label?: string;
    fields?: Array<string>;
    width?: number,   
}

const SearcherTableIncidentPayroll = <T extends Object>(
     {
    
     initState,
     setState,
     stateInitial,
     label = "Buscar",   
     width = 420,    
    }: Props<T>
) => {

    const handleChange = (e: any) => {
        const array=[...stateInitial]       
        if (e !== '') {           
                const nuevoFiltrado= array.filter((list:any) => {
                    return (    removeAccents(list.Colaborador.replace(/ /g, "").toLowerCase()).includes(removeAccents(e.replace(/ /g, "").toLowerCase()))
                             || removeAccents(list.Sede.toLowerCase()).includes(removeAccents(e.toLowerCase()))
                             || removeAccents(list.AreaProyecto.toLowerCase()).includes(removeAccents(e.toLowerCase()))
                    )
                })                       
               setState(nuevoFiltrado)
            }else{
               setState(stateInitial);            
           }               
        };   
    return (
        <Grid item>
            <Box >
                <Grid
                    container
                    direction="row"
                    style={{...style.containerSearcher, width: width}}
                >
                   <Grid item >
                        <input
                            style={{...style.inputSearcher, width: (width - 100)}}
                            className="collaboratorTab__searcher"
                            placeholder={label}
                            onChange={(e) => handleChange(e.target.value)}
                        />
                    </Grid>
                    <Grid item                        
                        style={{
                        width: "20px",
                        padding: "0 20px 0 40px",
                        color: "#7f7f81",
                        fontStyle: "bold",
                    }}>
                        <img                           
                            src="/assets/icons/icono-buscar.svg"
                            alt="Buscar"
                        />
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
};

export default SearcherTableIncidentPayroll
